export default "__VITE_ASSET__DqcOH35r__"